<script setup></script>

<template>
  <div class="antialiased">
    <div
      class="h-[28vh]  bg-primary"
      style="
        --marge: 50vh;
        mask-image: radial-gradient(
          circle at 50vw calc(-1 * var(--marge)),
          white 0%,
          white calc(var(--marge) + 28vh - 4rem),
          transparent calc(var(--marge) + 28vh),
          transparent 140%
        );
      "
    >
      <VBusHelper :emitOnMounted="$constants.EVENTS.ADS.LIST_ALL.REFRESH" />
      <AdsLoadingError
        v-if="$stores.ads?.state?.list_all?.error"
        @refresh="() => $bus.emit($constants.EVENTS.ADS.LIST_ALL.REFRESH)"
      >
        <template #errorDescription>
          {{ $stores.ads?.state?.list_all?.error }}
        </template>
      </AdsLoadingError>
      <div v-else-if="$stores.ads?.state?.list_all?.list.length" class="">
        <SwipperView
          v-slot="{ position, isActive }"
          :nbTabs="$stores.ads?.state?.list_all?.list.length"
          loop
          autoPlay
        >
          <component
            :is="
              $stores.ads?.state?.list_all?.list[position]?.targetUrl
                ? 'a'
                : 'div'
            "
            :href="$stores.ads?.state?.list_all?.list[position]?.targetUrl"
            target="_blank"
            class="w-full h-[28vh] block"
          >
            <ImgComponent
              :src="$stores.ads?.state?.list_all?.list[position]?.pictureUrl"
              class="object-cover w-full h-full"
              alt=""
            />
          </component>
        </SwipperView>
      </div>
      <div
        v-else-if="$stores.ads?.state?.list_all?.loading"
        class="shimmerContainer"
      >
        <SwipperView v-slot="{ position, isActive }" :nbTabs="3" loop autoPlay>
          <div class="w-full h-[28vh]">
            <div class="shimmerElement w-full h-full"></div>
          </div>
        </SwipperView>
      </div>
      <EmptyAds
        v-else
        @refresh="() => $bus.emit($constants.EVENTS.ADS.LIST_ALL.REFRESH)"
      />
      <!-- <div class="h-12 absolute w-full -translate-y-full z-10">
        <div
          class="w-full h-full"
          style="
            background: radial-gradient(
              circle at 40vw -1170px,
              #fff0 0%,
              #fff0 1200px,
              var(--color-primary-50) 1202px,
              var(--color-primary-50) 200vw
            );
          "
        ></div>
      </div> -->
    </div>
  </div>
</template>
